import { cn } from "@klarify/ui/lib/utils";
import type * as React from "react";
import TextareaAutosize from "react-textarea-autosize";

const Textarea = ({
	ref,
	className,
	rows,
	...props
}: React.ComponentProps<typeof TextareaAutosize>) => {
	return (
		<TextareaAutosize
			minRows={rows}
			className={cn(
				"flex h-9 w-full rounded-md border border-klarify-neutral-200 bg-white px-4 py-3 text-klarify-neutral-900 text-sm placeholder:text-klarify-gray-mod-400 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50",
				className,
			)}
			ref={ref}
			{...props}
		/>
	);
};
Textarea.displayName = "Textarea";

export { Textarea };
